import config from "./config";

const API_BASE = (config.apiUrl || "http://localhost:3000").replace(/\/$/, "");

async function request(path, options = {}) {
  const res = await fetch(`${API_BASE}${path}`, {
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
    ...options,
  });

  let data = {};
  try {
    data = await res.json();
  } catch {
    data = {};
  }

  if (!res.ok) {
    const error = new Error(data.error || "Request failed");
    error.status = res.status;
    error.lessonFinished = Boolean(data.lessonFinished);
    error.details = data;
    throw error;
  }

  return data;
}

export function importItems(rawText) {
  return request("/api/items/import", {
    method: "POST",
    body: JSON.stringify({ rawText }),
  });
}

export function getItems(limit = 20) {
  return request(`/api/items?limit=${limit}`);
}

export function deleteItem(itemId) {
  return request(`/api/items/${itemId}`, {
    method: "DELETE",
  });
}

export function startLesson() {
  return request("/api/lessons/start", {
    method: "POST",
  });
}

export function getNextCard(lessonId) {
  return request(`/api/lessons/${lessonId}/next`);
}

export function completeIntro(lessonId, itemId, alreadyKnown = false) {
  return request(`/api/lessons/${lessonId}/items/${itemId}/complete-intro`, {
    method: "POST",
    body: JSON.stringify({ alreadyKnown }),
  });
}

export function submitAnswer(lessonId, itemId, answers, hintCount) {
  return request(`/api/lessons/${lessonId}/items/${itemId}/answer`, {
    method: "POST",
    body: JSON.stringify({ answers, hintCount }),
  });
}